module.exports = __webpack_public_path__ + "img/main_slide_1.a80bb783.png";